export const DEFAULT_COOKIE_PATH = '/'

export const COOKIE_EXPIRY = 86_400 * 30
export const DELETE_COOKIE_EXPIRY = -99_999_999
